module.exports = __webpack_public_path__ + "@/assets/img/iphone.c198bd58.png";